import {
  PRIVACY_NOTICE_VERSION,
  legalDateLabel,
  privacyNoticeUrl,
} from "@school-sales-ai/shared";
import { LegalPageShell } from "@/components/legal/LegalPageShell";
import { PrivacyNoticeContent } from "@/components/legal/PrivacyNoticeContent";
import { brandFromLocation } from "@/lib/brand";

/**
 * Public, anonymous. The one page a real prospect is asked to read under the
 * LFPDPPP, linked by the agent from `privacyNoticeUrl(brand)` — the route must
 * not move without moving that too.
 *
 * The date is `PRIVACY_NOTICE_VERSION`, a fixed constant. It used to be today's
 * date, so the notice claimed to have been rewritten every day.
 */
export function AvisoDePrivacidad(): React.JSX.Element {
  const brand = brandFromLocation();
  const lastUpdated = legalDateLabel(PRIVACY_NOTICE_VERSION);

  return (
    <LegalPageShell
      brand={brand}
      canonicalHref={privacyNoticeUrl(brand)}
      lastUpdated={lastUpdated}
    >
      <PrivacyNoticeContent brand={brand} lastUpdated={lastUpdated} />
    </LegalPageShell>
  );
}
